/**
 * The canonical list of CSL item types — the single source of truth.
 *
 * Each entry is, identically: the CSL `type` value (a reference's `type`,
 * the schema's `properties.type.const`), the schema id (`$id`), and the
 * schema file basename under `dist/libs/cite/src/csl-schemas/<name>.schema.json`.
 * They are kept the same on purpose (the four spec types `legal_case`,
 * `motion_picture`, `musical_score`, `personal_communication` use underscores),
 * so consumers load schemas and match references off one list with no mapping.
 *
 * `CslType` is derived from this array, so the type and the runtime list can
 * never drift apart.
 */
export const CSL_TYPE_NAMES = [
  'article',
  'article-journal',
  'article-magazine',
  'article-newspaper',
  'bill',
  'book',
  'broadcast',
  'chapter',
  'classic',
  'collection',
  'dataset',
  'document',
  'entry',
  'entry-dictionary',
  'entry-encyclopedia',
  'event',
  'figure',
  'graphic',
  'hearing',
  'interview',
  'legal_case',
  'legislation',
  'manuscript',
  'map',
  'motion_picture',
  'musical_score',
  'pamphlet',
  'paper-conference',
  'patent',
  'performance',
  'periodical',
  'personal_communication',
  'post',
  'post-weblog',
  'regulation',
  'report',
  'review',
  'review-book',
  'software',
  'song',
  'speech',
  'standard',
  'thesis',
  'treaty',
  'webpage',
] as const;

export type CslType = (typeof CSL_TYPE_NAMES)[number];
